export default "__VITE_ASSET__Ixsf6pOB__"